import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { userLogin } from "../../Services/api";
import { toast } from 'react-toastify';
import NodeaxiosInstance from "../../Services/nodeaxios";
import { useUser } from "../../Components/UserContext";
import UserLogo from "../../Assets/Images/LogoUser.png"
import topBanaer from "../../Assets/Images/user_login_screen_top.png"

const LoginWithNumber = () => {
    const [isLoading, setLoadingStatus] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneNumberError, setPhoneNumberError] = useState("");
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const { appUser, setUser } = useUser();


    useEffect(() => {
        // if (!token) {
        //     navigate('/login'); 
        // }
        // let check = localStorage.getItem("login");
        // if (check == "Register") {
        //     navigate('/');
        // }
        // if (check == "logged") {
        //     navigate('/');
        // }

    }, []);

    const loginWithPhoneNumber = () => {
        setPhoneNumberError('');

        if (phoneNumber == '' || phoneNumber.length < 10 || phoneNumber.length > 10) {
            toast("Please enter your mobile number", {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                className: 'text-danger toast-style-1'
            });
            return
        }
        else {
            setLoadingStatus(true);

            NodeaxiosInstance.post("auth/login-send-otp", { phoneNumber: phoneNumber })
                .then((res) => {
                    if (res.data.status == "1") {

                        const updatedUser = {
                            ...appUser,
                            user_mbl: phoneNumber
                        };

                        // ✅ update context
                        setUser(updatedUser);
                        navigate('/otpVerification', { state: { mobileNumber: phoneNumber, flow: 'normalLogin' } });
                        setLoadingStatus(false);
                    }
                }, error => {
                    setLoadingStatus(false);
                    toast(error?.response?.data?.message, {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                        className: 'text-danger toast-style-1'
                    });
                    return
                });
        }
    }

    return (
        <>
            <div className=" bg-white ">
                <div className="position-relative">
                    <img src={topBanaer} height="110px" width="100%" />
                    <img src={UserLogo} height="80px" width="80px" className="rounded-3 position-absolute top-100 start-50 translate-middle  mb-2 " />
                </div>
                <div className="loginPage bg-white vh-100 d-flex align-items-center">
                    <div className="w-100">
                        <div className="ff-poppins-bold fs-24  mb-4">Login with  <br />
                            Phone Number</div>
                        <div className="input-group ff-poppins-regular">

                            <span className="input-group-text bg-white rounded-0 border-0 fs-20 secondary-text" id="loginByNumber-addon1">+91</span>
                            <input
                                type="tel"
                                value={phoneNumber}
                                onChange={(e) => {
                                    let input = e.target.value;
                                    input = input.replace(/\D/g, '');
                                    if (input.length > 10) input = input.slice(0, 10);
                                    if (input && !/^[6-9]/.test(input)) {
                                        return;
                                    }
                                    setPhoneNumber(input);
                                }}
                                className="form-control rounded-0 border-0 fs-20 secondary-text no-spinners"
                                placeholder="Phone Number"
                                aria-label="Mobile Number"
                                aria-describedby="loginByNumber-addon1"
                            />

                        </div>
                        <div className="fs-11 ff-poppins-semiBold primary-text d-flex justify-content-end mt-2" onClick={() => navigate('/login', { state: { fromGuest: true } })}>
                            <span>Login with email instead</span>
                        </div>

                        <div className="d-flex justify-content-center">
                            <button type="submit" onClick={loginWithPhoneNumber}
                                disabled={!phoneNumber || phoneNumber.length != 10 || isLoading}
                                className={(isLoading ? "loading" : "") + " " +
                                    `${!phoneNumber || phoneNumber.length != 10 ? "opacity-40" : ""} primary-bg  w-100 border-0 rounded-pill ff-poppins-semiBold fs-20 text-white mt-5 d-flex justify-content-center align-items-center`}>
                                {
                                    isLoading
                                        ?
                                        <span className="loader-style-1"></span>
                                        :
                                        <span>Send OTP</span>
                                }
                            </button>

                        </div>
                        <div className="text-center fs-12 ff-poppins-medium mt-2" onClick={() => navigate('/login', { state: { tabName: "Register", fromGuest: true } })}>
                            Don't have an account?
                            <span className="primary-text ms-1">Register.</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default LoginWithNumber;